<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 10H5C4.44771 10 4 10.4477 4 11V15C4 15.5523 4.44771 16 5 16H27C27.5523 16 28 15.5523 28 15V11C28 10.4477 27.5523 10 27 10Z"
      stroke="#0E0E22"
      stroke-opacity="0.8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26 16V25C26 25.2652 25.8946 25.5196 25.7071 25.7071C25.5196 25.8946 25.2652 26 25 26H7C6.73478 26 6.48043 25.8946 6.29289 25.7071C6.10536 25.5196 6 25.2652 6 25V16"
      stroke="#0E0E22"
      stroke-opacity="0.8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 10V26"
      stroke="#0E0E22"
      stroke-opacity="0.8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.6569 8.58569C20.2426 9.9999 16 9.9999 16 9.9999C16 9.9999 16 5.75726 17.4142 4.34305C17.9769 3.78097 18.7398 3.46535 19.5352 3.46558C20.3305 3.4658 21.0932 3.78186 21.6556 4.34426C22.218 4.90666 22.5341 5.66937 22.5343 6.46472C22.5346 7.26008 22.2189 8.02297 21.6569 8.58569V8.58569Z"
      stroke="#0E0E22"
      stroke-opacity="0.8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.3432 8.58569C11.7574 9.9999 16 9.9999 16 9.9999C16 9.9999 16 5.75726 14.5858 4.34305C14.0231 3.78097 13.2602 3.46535 12.4648 3.46558C11.6695 3.4658 10.9068 3.78186 10.3444 4.34426C9.78198 4.90666 9.46592 5.66937 9.4657 6.46472C9.46547 7.26008 9.78109 8.02297 10.3432 8.58569V8.58569Z"
      stroke="#0E0E22"
      stroke-opacity="0.8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
